<p-dialog header="{{ 'BookingHeaderDetails.Form.CertificateDownload' | translate }}" [(visible)]="isVisible" appendTo="body" (visibleChange)="dialogVisibleChange($event)"
  [modal]="true" [draggable]="false" [resizable]="false" [style]="{ width: '80%' }">


  <h2>{{ 'BookingSearch.Form.BookingNo' | translate }} {{ booking?.bookingNo }}</h2>

  <laas-data-table [value]="importDocData" [defaultColumns]="columns" [(selectedRows)]="selectedOriginCertificateDatas"
    [dataKey]="'index'" [selectable]="true" [tableKey]="preferenceKey" >

      <ng-template pTemplate="body" let-rowData let-columns="columns">
        <td *ngFor="let col of columns">
          <ng-container [ngSwitch]="col.field">
            <ng-container *ngSwitchDefault>
              <div [ngSwitch]="col.dataType">
                  <ng-container *ngSwitchCase="'date'">
                    <div class="overflow-text">
                      {{ rowData[col.field] | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}
                    </div>
                  </ng-container>
                  <ng-container *ngSwitchDefault>
                    <div class="overflow-text">
                      {{ rowData[col.field] | replaceNullWith:'-'}}
                    </div>
                  </ng-container>
              </div>
            </ng-container>
          </ng-container>
        </td>
      </ng-template>

  </laas-data-table>

  <div  class="mt-2 text-center">
      <button class="ml-2 mr-2" pRipple pButton label="{{ 'BookingSearch.SubTable.Button.DownloadExport' | translate }}"
      (click)="getCertificateFile($event)"></button>
      <button class="ml-2 mr-2" pRipple pButton label="{{ 'BookingSearch.SubTable.Button.DownloadExportExcel' | translate }}"
      (click)="downloadAttachFile()"></button>
  </div>

</p-dialog>
